import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'hedron';
import BlackLine from './BlackLine';

const Divider = ({ size, padding }) => (
  <Row style={{ padding }}>
    <Column fluid>
      <BlackLine size={size} />
    </Column>
  </Row>
);

Divider.propTypes = {
  padding: PropTypes.string,
  size: PropTypes.number
};
export default Divider;
